{
  "title": "Mobile App",
  "description": "Manage mobile app versions and store links",
  "iosVersion": "iOS Version",
  "androidVersion": "Android Version",
  "iosStoreUrl": "App Store URL",
  "androidStoreUrl": "Play Store URL",
  "edit": "Edit",
  "editDialog": {
    "title": "Edit {{field}}",
    "description": "Are you sure you want to modify this value?",
    "currentValue": "Current value: {{value}}",
    "newValue": "New value",
    "cancel": "Cancel",
    "confirm": "Confirm"
  },
  "success": {
    "updated": "App version updated successfully"
  },
  "errors": {
    "fetchFailed": "Failed to fetch app version",
    "updateFailed": "Failed to update app version"
  }
}
